<template>
	<div class="rightTab">
		<div class="relative">
			<svgIcon iconClass="phone" class="svg"/>
			电话咨询
			<div class="">
				<svgIcon iconClass="kefu" class="svg" style="color:#004727"/>
				400 0592 568
			</div>
		</div>
		<div class="relative">
			<svgIcon iconClass="zixun" class="svg"/>
			在线咨询
			<div class="">
				<img src="@/style/img/ucode.png" alt="">
			</div>
		</div>
		<div @click="backTop">
			<svgIcon iconClass="top" class="svg"/>
			回到顶部
		</div>
	</div>
</template>

<script>
	export default {
		name: 'rightTab',
		data() {
			return {
				scrollTop:0
			}
		},
		mounted() {
			window.addEventListener("scroll", this.showbtn, true);
		},
		methods: {
			showbtn() {
				let that = this;
				let scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop;
				that.scrollTop = scrollTop;
			},
			backTop() {
				let timer = setInterval(res => {
					let osTop = document.documentElement.scrollTop || document.body.scrollTop;
					let ispeed = Math.floor(-osTop / 6);
					document.documentElement.scrollTop = document.body.scrollTop = osTop + ispeed;
					if (osTop === 0) {
						clearInterval(timer);
					}
				}, 30);
			}
		}
	}
</script>

<style scoped>
	.rightTab {
		display: flex;
		flex-direction: column;
		/* width: 70px; */
		/* height: 287px; */
		background: #FFFFFF;
		box-shadow: 0px 0px 9px 1px rgba(0, 71, 39, 0.2);
		border-radius: 4px 0px 0px 4px;
		text-align: center;
		justify-content: center;
		position: fixed;
		right: 54px;
		top: 50%;
		z-index: 999;
		font-size: 12px;
		padding: 28px 11px;
		border-radius: 17px;
	}
	.rightTab div div{
		position: absolute;
		left: -250px;
		top: -60px;
		bottom: 0;
		margin: auto;
		width: 216px;
		height: 72px;
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 24px;
		color: #004727;
		font-weight: bold;
		background: #fff;
		margin: 0;
		display: none;
		transition: all 1s;
	}
	.rightTab div div::after{
		content: '';
		width: 0;
		height: 0;
		border-top: 10px solid transparent;
		border-left: 10px solid #fff;
		border-bottom: 10px solid transparent;
		position: absolute;
		right: -10px;
	}
	.rightTab div div .svg{
		width: 22px;
		height: 22px;
		margin: 0;
		margin-right: 9px;
		color: #004727;
	}
	.rightTab div:nth-child(1):hover div,
	.rightTab div:nth-child(2):hover div{
		display: flex;
	}
	
	.rightTab div:nth-child(2) div{
		width: 180px;
		height: 180px;
		top: -130px;
		left: -215px;
	}
	.rightTab div:nth-child(2) div .svg{
		width: 192px;
		height: 192px;
		margin: 6px auto;
	}
	.rightTab .svg {
		width: 20px;
		height: 20px;
		display: block;
		margin: 0 auto;
		margin-bottom: 14px;
		color: #004727;
	}

	.rightTab div:nth-child(2) {
		margin: 43px 0;
	}
	
</style>
